module.exports = __webpack_public_path__ + "img/属性语义.0c9ff142.svg";